module.exports = __webpack_public_path__ + "img/MInvoice.69256cbf.svg";